// extracted by mini-css-extract-plugin
module.exports = {"info":"styles_info__Ejb8_","dataLabel":"styles_dataLabel__3baJY","data":"styles_data__1Urzb"};